import { Menu, MenuItem, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReturnNodeDto } from "~/api/GeneratedApi";

interface Props {
  currentContextMenuNode: ReturnNodeDto | undefined;
  contextMenuPosition: { mouseX: number | null; mouseY: number | null };
  createFolder: (node: ReturnNodeDto) => void;
  handleClose: () => void;
}

const FileExplorerTreeContextMenu = ({
  currentContextMenuNode,
  createFolder,
  contextMenuPosition,
  handleClose,
}: Props): JSX.Element => {
  const { t } = useTranslation("file-explorer");

  const disableMutations =
    currentContextMenuNode?.programManaged ||
    currentContextMenuNode?.reserved ||
    currentContextMenuNode?.parentReserved;

  return (
    <Menu
      keepMounted
      open={contextMenuPosition.mouseY !== null}
      onContextMenu={(evt) => {
        evt.preventDefault();
        handleClose();
      }}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenuPosition.mouseY !== null &&
        contextMenuPosition.mouseX !== null
          ? {
              top: contextMenuPosition.mouseY,
              left: contextMenuPosition.mouseX,
            }
          : undefined
      }
      // PaperProps={{ style: { pointerEvents: "auto" } }}
      // style={{ pointerEvents: "none" }}
    >
      <Tooltip
        title={
          disableMutations ? t("folder-is-program-managed").toString() : ""
        }
      >
        <span>
          <MenuItem
            dense
            disabled={disableMutations ?? true}
            onClick={() => {
              handleClose();
              if (!currentContextMenuNode) return;
              createFolder(currentContextMenuNode);
            }}
          >
            {t("new-folder")}
          </MenuItem>
        </span>
      </Tooltip>
    </Menu>
  );
};

export default FileExplorerTreeContextMenu;
